<div class="search-box" *ngIf="true" [ngClass]="{'search-box-focus-within': search_input_focus}"
[ngStyle]="{'width': width, 'top': top, 'left': left}">
    <div class="search-input-container" [ngClass]="{'seach-input-container-focus-within': search_input_focus}" (click)="search_input_element.nativeElement.focus()">
        <button (click)="onBackButtonClick.emit($event); $event.stopPropagation()" *ngIf="showBackButton">
            <img src="assets/navbar-component-images/fluent_ios-arrow-24-filled.svg" alt="assets/navbar-component-images/fluent_ios-arrow-24-filled.svg">
        </button>
        <img class="search-icon" [src]="search_icon_1" alt="search_icon_1">
        <input pInputText autocomplete="off" maxlength="512" [ngClass]="'searchInput'" #searchInput [formControl]="search_input" (focus)="onInputFocus()" (blur)="onInputBlur()" placeholder="ค้นหาสิ่งที่คุณสนใจ..">
        <button class="hidden" (mousedown)="onClearClick($event)">
            <img [src]="cross_icon" alt="cross_icon">
        </button>
        <img class="line hidden" [src]="line_icon" alt="line_icon">
        <div class="button-and-word-count-container">
            <div class="search-button-container">
                <button class="search-button" (click)="onSearchClick(); $event.stopPropagation()">
                    <img [src]="search_button_icon" alt="search_button_icon">
                </button>
                <!-- voice_search change AI button -->
                <button class="search-button" (click)="onAiSearchClick(); $event.stopPropagation()" style="color: aliceblue; font-weight: bold;">Ai</button>
            </div>
            <p class="hidden">{{ search_input.value.toString().length }}/512</p>
        </div>
    </div>
    <div class="search-output-container hidden"(mousedown)="preventBlur($event)">
        <div class="search-output-result-container">
            <div class="search-output-result" 
            *ngFor="let suggestion of suggestions; index as index" 
            (click)="onResultSuggestionClick(suggestion)" 
            [ngClass]="{'selected': index == search_result_active}" 
            (mouseenter)="onResultHover(index)" 
            (mouseleave)="onResultLeave()">
                <img [src]="getSearchResultIcon(index)" alt="search_result_icon">
                <label>{{ suggestion }}</label>
                <!-- <img class="hidden" [src]="enter_icon" alt="enter-icon" [ngClass]="{'selected': index == search_result_active}"> -->
            </div>
        </div>
    </div>
    <div class="search-output-meta-container hidden" (mousedown)="preventBlur($event)">
        <span>{{ suggestions.length }} results</span>
        <span><img [src]="meta_select_icon" alt="meta_select_icon"> Select</span>
        <span><img [src]="meta_open_icon" alt="meta_open_icon"> Open</span>
    </div>
</div>